import { render, staticRenderFns } from "./alreadySentManuscript.vue?vue&type=template&id=4beaccdf&scoped=true&"
import script from "./alreadySentManuscript.vue?vue&type=script&lang=js&"
export * from "./alreadySentManuscript.vue?vue&type=script&lang=js&"
import style0 from "./alreadySentManuscript.vue?vue&type=style&index=0&id=4beaccdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beaccdf",
  null
  
)

export default component.exports